/*
  Mobile search: <ds-drawer id="search-drawer"> (snippets/header-overlays.liquid).

  The drawer shell lives at body level; its body is cloned on first open from
  <template id="SearchDrawerContent"> in the header section
  (snippets/header-search-mobile.liquid). Open/close, Escape, scroll lock,
  inert page, focus trap/return and autofocus of the input
  ([data-drawer-autofocus]) come from the primitive (assets/ds-drawer.js).
  predictive-search.js upgrades the cloned <predictive-search> on insertion.

  Also defines window.IceboxSearchBestSellers, shared with the desktop
  dropdown (desktop-search-dropdown.js).
*/

/*
  Best sellers for both search panels. Fetched once per session on first open
  of either panel from sections/search-best-sellers.liquid via the Section
  Rendering API, cached in sessionStorage (keyed by theme, market and
  currency), and injected into every [data-search-best-sellers] slot. The
  slots show a skeleton until then.
*/
(function () {
  if (window.IceboxSearchBestSellers) return;

  var SECTION_ID = 'search-best-sellers';
  var CACHE_VERSION = 'v1';
  var request = null;

  function cacheKey() {
    var s = window.Shopify || {};
    return [
      'icebox:search-best-sellers',
      CACHE_VERSION,
      (s.theme && s.theme.id) || '0',
      s.locale || '',
      s.country || '',
      (s.currency && s.currency.active) || '',
    ].join(':');
  }

  function readCache() {
    try {
      return window.sessionStorage.getItem(cacheKey());
    } catch (error) {
      return null;
    }
  }

  function writeCache(html) {
    try {
      window.sessionStorage.setItem(cacheKey(), html);
    } catch (error) {}
  }

  function slots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-search-best-sellers]'));
  }

  function sourceUrl() {
    var slot = slots()[0];
    var handle = (slot && slot.dataset.collection) || 'best-sellers';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'collections/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID;
  }

  function fill(html) {
    slots().forEach(function (slot) {
      var section = slot.closest('[data-search-best-sellers-section]');
      if (html === null) {
        // Failed: hide the row for now; the next open retries.
        if (section) section.hidden = true;
        return;
      }
      if (slot.dataset.filled !== 'true') {
        slot.innerHTML = html;
        slot.dataset.filled = 'true';
        slot.removeAttribute('aria-busy');
      }
      if (section) section.hidden = !html;
    });
  }

  function fetchHtml() {
    return fetch(sourceUrl(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var content = doc.querySelector('[data-search-best-sellers-content]');
        var html = content ? content.innerHTML.trim() : '';
        writeCache(html);
        return html;
      });
  }

  function load() {
    if (!request) {
      var cached = readCache();
      request = cached !== null ? Promise.resolve(cached) : fetchHtml();
      request = request.catch(function () {
        request = null;
        return null;
      });
    }
    return request.then(function (html) {
      fill(html);
      return html;
    });
  }

  window.IceboxSearchBestSellers = { load: load };
})();

(function () {
  if (window.__icMobileSearchDrawerBound) return;
  window.__icMobileSearchDrawerBound = true;

  var DRAWER_ID = 'search-drawer';
  var TEMPLATE_ID = 'SearchDrawerContent';
  var desktopQuery = window.matchMedia('(min-width: 990px)');

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  function getBody(drawer) {
    return drawer && drawer.querySelector('[data-search-drawer-body]');
  }

  function hydrate(drawer) {
    var body = getBody(drawer);
    var template = document.getElementById(TEMPLATE_ID);
    if (!body || !template) return;
    if (!template.dataset.renderId) template.dataset.renderId = String(Date.now());
    if (body.dataset.hydratedFrom === template.dataset.renderId) return;
    body.replaceChildren(template.content.cloneNode(true));
    body.dataset.hydratedFrom = template.dataset.renderId;
  }

  function bindDrawer() {
    var drawer = getDrawer();
    if (!drawer || drawer.dataset.searchBound === 'true') return;
    drawer.dataset.searchBound = 'true';

    drawer.onBeforeOpen = function () {
      hydrate(drawer);
      if (window.IceboxSearchBestSellers) window.IceboxSearchBestSellers.load();
    };
  }

  function onDesktopChange(event) {
    var drawer = getDrawer();
    if (event.matches && drawer && drawer.isOpen) drawer.close({ reason: 'breakpoint', restoreFocus: false });
  }

  if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onDesktopChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDrawer, { once: true });
  } else {
    bindDrawer();
  }

  // Theme editor: the header section re-rendered, so its template is new.
  document.addEventListener('shopify:section:load', function () {
    var drawer = getDrawer();
    if (drawer && drawer.isOpen) drawer.close({ reason: 'section-load', restoreFocus: false });
    var body = getBody(drawer);
    if (body) delete body.dataset.hydratedFrom;
    bindDrawer();
  });
})();

/*
  Mobile search row (≤989px) — scroll behaviour and layout variables.

  The row (.header__msearch) sits under the sticky nav. It is NOT sticky: it
  slides up behind the nav on scroll down and returns on scroll up (ported from
  the Swiss Watches pattern). State is the `is-msearch-hidden` class on
  .section-header; CSS does the rest (see component-mobile-search-drawer.css).

  Variables published on :root (updated on resize / ResizeObserver):
    --ic-msearch-h      row height (0px on desktop)
    --ic-msearch-y      current translateY of the row (0px, or -height when hidden)
    --ic-sticky-offset  banner + header height (+ row height while the row is
                        showing), i.e. where sticky content below the nav
                        should stick. Published at every width.

  Re-executing this script (theme editor header reload) tears down the previous
  instance first so listeners and observers never stack.
*/
(function () {
  if (window.__icMobileSearchRow && typeof window.__icMobileSearchRow.destroy === 'function') {
    window.__icMobileSearchRow.destroy();
  }

  var HIDE_AFTER = 24; // px of continuous downward travel before hiding
  var SHOW_AFTER = 48; // px of continuous upward travel before showing again
  var TOP_REGION = 80; // never hide while scrollY is inside this region
  var TOP_EPSILON = 2; // "back at the top" tolerance
  var ANIMATION_MS = 350;

  var OVERLAY_SELECTOR = 'ds-drawer.is-open';

  // Attribute mutations on these can mean a drawer / modal opened or closed.
  var RELEVANT_TARGETS = ['html', 'body', '.section-header', 'ds-drawer'].join(',');

  var root = document.documentElement;
  var mobileQuery = window.matchMedia('(max-width: 989px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var section = null;
  var row = null;
  var hidden = false;
  var lastY = 0;
  var direction = 0;
  var travel = 0;
  var rafId = 0;
  var animTimer = 0;
  var resizeObserver = null;
  var mutationObserver = null;
  var bound = false;

  function isMobile() {
    return mobileQuery.matches;
  }

  function setVar(name, value) {
    root.style.setProperty(name, value);
  }

  function currentY() {
    return window.pageYOffset || root.scrollTop || 0;
  }

  function publish() {
    var rowHeight = row && isMobile() ? row.offsetHeight : 0;
    var headerHeight = section ? section.offsetHeight : 0;
    var showing = isMobile() && !hidden;

    setVar('--ic-msearch-h', rowHeight + 'px');
    setVar('--ic-msearch-y', (isMobile() && hidden ? -rowHeight : 0) + 'px');
    // Banner + nav (+ row): the banner publishes its own height, so reference it
    // instead of measuring it again.
    setVar(
      '--ic-sticky-offset',
      'calc(var(--announcement-bar-height, 0px) + ' + (headerHeight + (showing ? rowHeight : 0)) + 'px)'
    );
  }

  function setHidden(next, animate) {
    if (!section || !row || hidden === next) return;
    hidden = next;

    if (animate && !reducedMotion.matches) {
      row.classList.add('is-animating');
      window.clearTimeout(animTimer);
      animTimer = window.setTimeout(function () {
        row.classList.remove('is-animating');
      }, ANIMATION_MS);
    }

    section.classList.toggle('is-msearch-hidden', hidden);
    publish();
  }

  // Any drawer or other modal that locks page scroll (lockBodyScroll adds
  // body.overflow-hidden): the row stays visible while one is open.
  function isOverlayOpen() {
    var body = document.body;
    if (!body) return false;
    if (body.classList.contains('overflow-hidden') || root.classList.contains('drawer-open')) return true;
    return !!document.querySelector(OVERLAY_SELECTOR);
  }

  function update() {
    rafId = 0;
    if (!section || !row || !isMobile()) return;

    var y = currentY();
    var maxY = Math.max(0, root.scrollHeight - window.innerHeight);

    // iOS rubber-band overscroll reports scrollY outside the document.
    if (y < 0 || y > maxY + 1) return;

    if (isOverlayOpen()) {
      setHidden(false, true);
      lastY = y;
      travel = 0;
      return;
    }

    var scrolledPast = section.classList.contains('scrolled-past-header');
    var delta = y - lastY;
    lastY = y;

    // Never hide while the nav is still transparent over the hero (the row
    // would slide visibly under a see-through bar), and always show at the top.
    if (!scrolledPast || y <= TOP_EPSILON) {
      setHidden(false, true);
      if (delta === 0) return;
    }

    if (delta === 0) return;

    var dir = delta > 0 ? 1 : -1;
    if (dir !== direction) {
      direction = dir;
      travel = 0;
    }
    travel += Math.abs(delta);

    if (!scrolledPast || y <= TOP_EPSILON) return;

    if (dir === 1) {
      if (travel > HIDE_AFTER && y > TOP_REGION) setHidden(true, true);
    } else if (travel > SHOW_AFTER) {
      setHidden(false, true);
    }
  }

  function schedule() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(update);
  }

  function onResize() {
    publish();
    schedule();
  }

  function onBreakpointChange() {
    if (!isMobile()) {
      hidden = false;
      window.clearTimeout(animTimer);
      if (section) section.classList.remove('is-msearch-hidden');
      if (row) row.classList.remove('is-animating');
    }
    lastY = currentY();
    travel = 0;
    direction = 0;
    publish();
  }

  function onPageShow() {
    lastY = currentY();
    publish();
    schedule();
  }

  function onMutations(records) {
    for (var i = 0; i < records.length; i += 1) {
      var target = records[i].target;
      if (target && target.nodeType === 1 && target.matches(RELEVANT_TARGETS)) {
        schedule();
        return;
      }
    }
  }

  function teardown() {
    if (rafId) window.cancelAnimationFrame(rafId);
    rafId = 0;
    window.clearTimeout(animTimer);

    if (bound) {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
      window.removeEventListener('pageshow', onPageShow);
      if (mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', onBreakpointChange);
      bound = false;
    }

    if (resizeObserver) resizeObserver.disconnect();
    if (mutationObserver) mutationObserver.disconnect();
    resizeObserver = null;
    mutationObserver = null;
  }

  function init() {
    teardown();

    section = document.querySelector('.section-header');
    row = section ? section.querySelector('.header__msearch') : null;
    hidden = !!(section && section.classList.contains('is-msearch-hidden'));
    lastY = currentY();
    direction = 0;
    travel = 0;

    publish();
    if (!section || !row) return;

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize);
    window.addEventListener('pageshow', onPageShow);
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onBreakpointChange);
    bound = true;

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(publish);
      resizeObserver.observe(row);
      resizeObserver.observe(section);
    }

    if ('MutationObserver' in window) {
      mutationObserver = new MutationObserver(onMutations);
      mutationObserver.observe(root, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'open'],
      });
    }

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(publish);
    schedule();
  }

  window.__icMobileSearchRow = { init: init, destroy: teardown };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Theme editor: the header section re-renders; rebind to the fresh DOM.
  if (!window.__icMobileSearchRowSectionLoadBound) {
    window.__icMobileSearchRowSectionLoadBound = true;
    document.addEventListener('shopify:section:load', function () {
      if (window.__icMobileSearchRow) window.__icMobileSearchRow.init();
    });
  }
})();
